export const prospectorEditDisabledMessage: string =
    "This data originated from the Prospector tool, and can therefore not be edited.";

export const us_states: {
    name: string;
    abbreviation: string;
    latitude: number;
    longitude: number;
    width_km: number;
}[] =
    // Full list of US states + DC, now with lat, lng, and approximate width in kilometers:
    [
        {
            name: "Alabama",
            abbreviation: "AL",
            latitude: 32.806671,
            longitude: -86.79113,
            width_km: 510,
        },
        {
            name: "Alaska",
            abbreviation: "AK",
            latitude: 61.370716,
            longitude: -152.404419,
            width_km: 4000,
        },
        {
            name: "Arizona",
            abbreviation: "AZ",
            latitude: 33.729759,
            longitude: -111.431221,
            width_km: 640,
        },
        {
            name: "Arkansas",
            abbreviation: "AR",
            latitude: 34.969704,
            longitude: -92.373123,
            width_km: 386,
        },
        {
            name: "California",
            abbreviation: "CA",
            latitude: 36.116203,
            longitude: -119.681564,
            width_km: 900,
        },
        {
            name: "Colorado",
            abbreviation: "CO",
            latitude: 39.059811,
            longitude: -105.311104,
            width_km: 612,
        },
        {
            name: "Connecticut",
            abbreviation: "CT",
            latitude: 41.597782,
            longitude: -72.755371,
            width_km: 177,
        },
        {
            name: "Delaware",
            abbreviation: "DE",
            latitude: 39.318523,
            longitude: -75.507141,
            width_km: 48,
        },
        {
            name: "District of Columbia",
            abbreviation: "DC",
            latitude: 38.905985,
            longitude: -77.033418,
            width_km: 16,
        },
        {
            name: "Florida",
            abbreviation: "FL",
            latitude: 27.766279,
            longitude: -81.686783,
            width_km: 581,
        },
        {
            name: "Georgia",
            abbreviation: "GA",
            latitude: 33.040619,
            longitude: -83.643074,
            width_km: 480,
        },
        {
            name: "Hawaii",
            abbreviation: "HI",
            latitude: 21.094318,
            longitude: -157.498337,
            width_km: 800,
        },
        {
            name: "Idaho",
            abbreviation: "ID",
            latitude: 44.240459,
            longitude: -114.478828,
            width_km: 491,
        },
        {
            name: "Illinois",
            abbreviation: "IL",
            latitude: 40.349457,
            longitude: -88.986137,
            width_km: 338,
        },
        {
            name: "Indiana",
            abbreviation: "IN",
            latitude: 39.849426,
            longitude: -86.258278,
            width_km: 225,
        },
        {
            name: "Iowa",
            abbreviation: "IA",
            latitude: 42.011539,
            longitude: -93.210526,
            width_km: 499,
        },
        {
            name: "Kansas",
            abbreviation: "KS",
            latitude: 38.5266,
            longitude: -96.726486,
            width_km: 660,
        },
        {
            name: "Kentucky",
            abbreviation: "KY",
            latitude: 37.66814,
            longitude: -84.670067,
            width_km: 684,
        },
        {
            name: "Louisiana",
            abbreviation: "LA",
            latitude: 31.169546,
            longitude: -91.867805,
            width_km: 480,
        },
        {
            name: "Maine",
            abbreviation: "ME",
            latitude: 44.693947,
            longitude: -69.381927,
            width_km: 330,
        },
        {
            name: "Maryland",
            abbreviation: "MD",
            latitude: 39.063946,
            longitude: -76.802101,
            width_km: 400,
        },
        {
            name: "Massachusetts",
            abbreviation: "MA",
            latitude: 42.230171,
            longitude: -71.530106,
            width_km: 185,
        },
        {
            name: "Michigan",
            abbreviation: "MI",
            latitude: 43.326618,
            longitude: -84.536095,
            width_km: 785,
        },
        {
            name: "Minnesota",
            abbreviation: "MN",
            latitude: 45.694454,
            longitude: -93.900192,
            width_km: 600,
        },
        {
            name: "Mississippi",
            abbreviation: "MS",
            latitude: 32.741646,
            longitude: -89.678697,
            width_km: 275,
        },
        {
            name: "Missouri",
            abbreviation: "MO",
            latitude: 38.456085,
            longitude: -92.288368,
            width_km: 480,
        },
        {
            name: "Montana",
            abbreviation: "MT",
            latitude: 46.921925,
            longitude: -110.454353,
            width_km: 1015,
        },
        {
            name: "Nebraska",
            abbreviation: "NE",
            latitude: 41.12537,
            longitude: -98.268082,
            width_km: 725,
        },
        {
            name: "Nevada",
            abbreviation: "NV",
            latitude: 38.313515,
            longitude: -117.055374,
            width_km: 788,
        },
        {
            name: "New Hampshire",
            abbreviation: "NH",
            latitude: 43.452492,
            longitude: -71.563896,
            width_km: 145,
        },
        {
            name: "New Jersey",
            abbreviation: "NJ",
            latitude: 40.298904,
            longitude: -74.521013,
            width_km: 113,
        },
        {
            name: "New Mexico",
            abbreviation: "NM",
            latitude: 34.840515,
            longitude: -106.248482,
            width_km: 595,
        },
        {
            name: "New York",
            abbreviation: "NY",
            latitude: 42.165726,
            longitude: -74.948051,
            width_km: 530,
        },
        {
            name: "North Carolina",
            abbreviation: "NC",
            latitude: 35.630066,
            longitude: -79.806419,
            width_km: 900,
        },
        {
            name: "North Dakota",
            abbreviation: "ND",
            latitude: 47.528912,
            longitude: -99.784012,
            width_km: 539,
        },
        {
            name: "Ohio",
            abbreviation: "OH",
            latitude: 40.388783,
            longitude: -82.764915,
            width_km: 355,
        },
        {
            name: "Oklahoma",
            abbreviation: "OK",
            latitude: 35.565342,
            longitude: -96.928917,
            width_km: 756,
        },
        {
            name: "Oregon",
            abbreviation: "OR",
            latitude: 44.572021,
            longitude: -122.070938,
            width_km: 644,
        },
        {
            name: "Pennsylvania",
            abbreviation: "PA",
            latitude: 40.590752,
            longitude: -77.209755,
            width_km: 455,
        },
        {
            name: "Rhode Island",
            abbreviation: "RI",
            latitude: 41.680893,
            longitude: -71.51178,
            width_km: 60,
        },
        {
            name: "South Carolina",
            abbreviation: "SC",
            latitude: 33.856892,
            longitude: -80.945007,
            width_km: 459,
        },
        {
            name: "South Dakota",
            abbreviation: "SD",
            latitude: 44.299782,
            longitude: -99.438828,
            width_km: 611,
        },
        {
            name: "Tennessee",
            abbreviation: "TN",
            latitude: 35.747845,
            longitude: -86.692345,
            width_km: 692,
        },
        {
            name: "Texas",
            abbreviation: "TX",
            latitude: 31.054487,
            longitude: -97.563461,
            width_km: 1239,
        },
        {
            name: "Utah",
            abbreviation: "UT",
            latitude: 40.150032,
            longitude: -111.862434,
            width_km: 435,
        },
        {
            name: "Vermont",
            abbreviation: "VT",
            latitude: 44.045876,
            longitude: -72.710686,
            width_km: 145,
        },
        {
            name: "Virginia",
            abbreviation: "VA",
            latitude: 37.769337,
            longitude: -78.169968,
            width_km: 692,
        },
        {
            name: "Washington",
            abbreviation: "WA",
            latitude: 47.400902,
            longitude: -121.490494,
            width_km: 580,
        },
        {
            name: "West Virginia",
            abbreviation: "WV",
            latitude: 38.491226,
            longitude: -80.954453,
            width_km: 370,
        },
        {
            name: "Wisconsin",
            abbreviation: "WI",
            latitude: 44.268543,
            longitude: -89.616508,
            width_km: 475,
        },
        {
            name: "Wyoming",
            abbreviation: "WY",
            latitude: 42.755966,
            longitude: -107.30249,
            width_km: 580,
        },
    ];

export const develop_us_states: {
    name: string;
    abbreviation: string;
    latitude: number;
    longitude: number;
    width_km: number;
}[] = [
    {
        name: "Alaska",
        abbreviation: "AK",
        latitude: 61.370716,
        longitude: -152.404419,
        width_km: 4000,
    },
    {
        name: "District of Columbia",
        abbreviation: "DC",
        latitude: 38.905985,
        longitude: -77.033418,
        width_km: 16,
    },
    {
        name: "Hawaii",
        abbreviation: "HI",
        latitude: 21.094318,
        longitude: -157.498337,
        width_km: 800,
    },
    {
        name: "Montana",
        abbreviation: "MT",
        latitude: 46.921925,
        longitude: -110.454353,
        width_km: 1015,
    },
    {
        name: "North Dakota",
        abbreviation: "ND",
        latitude: 47.528912,
        longitude: -99.784012,
        width_km: 539,
    },
    {
        name: "Rhode Island",
        abbreviation: "RI",
        latitude: 41.680893,
        longitude: -71.51178,
        width_km: 60,
    },
    {
        name: "South Dakota",
        abbreviation: "SD",
        latitude: 44.299782,
        longitude: -99.438828,
        width_km: 611,
    },
    {
        name: "Wyoming",
        abbreviation: "WY",
        latitude: 42.755966,
        longitude: -107.30249,
        width_km: 580,
    },
];

export const prospectorFilters = {
    __FREQUENTLY_USED: {
        name: "Filters",
        type: "top",
        list: {
            Dwelling_Type: {
                name: "Dwelling Type",
                type: "checklist",
                options: [
                    { name: "Multiple Family Dwelling Unit", value: "M" },
                    { name: "Single Family Dwelling Unit", value: "S" },
                    { name: "Unknown", value: "" },
                ],
            },
            Homeowner_Probability_Model: {
                name: "Homeowner",
                type: "checklist",
                options: [
                    { name: "Home Owner", value: "H" },
                    { name: "Probable Home Owner", value: "9" },
                    { name: "Renter", value: "R" },
                    { name: "Unknown", value: "" },
                ],
            },
            Property_Home_Square_Footage: {
                name: "Home Square Footage",
                type: "number",
                min: 1,
                max: 100000,
            },
            Home_Year_Built: {
                name: "Home Build Year",
                type: "number",
                min: "1800",
                max: "2024",
            },
            Home_Purchase_Year: {
                name: "Home Purchase Year",
                type: "number",
                min: "1919",
                max: "2024",
            },
            Home_Purchase_Price: {
                name: "Home Purchase Price",
                type: "number",
                min: 1,
                max: 1000000000,
            },
            Credit_Rating: {
                name: "Credit Rating",
                type: "checklist",
                options: [
                    { name: "Unknown", value: "" },
                    { name: "Under 499", value: "H" },
                    { name: "500-549", value: "G" },
                    { name: "550-599", value: "F" },
                    { name: "600-649", value: "E" },
                    { name: "650-699", value: "D" },
                    { name: "700-749", value: "C" },
                    { name: "750-799", value: "B" },
                    { name: "800+", value: "A" },
                ],
            },
            Estimated_Income_Code: {
                name: "Income Range",
                type: "checklist",
                options: [
                    { name: "Unknown", value: "" },
                    { name: "Under $10,000", value: "A" },
                    { name: "$10,000 - $14,999", value: "B" },
                    { name: "$15,000 - $19,999", value: "C" },
                    { name: "$20,000 - $24,999", value: "D" },
                    { name: "$25,000 - $29,999", value: "E" },
                    { name: "$30,000 - $34,999", value: "F" },
                    { name: "$35,000 - $39,999", value: "G" },
                    { name: "$40,000 - $44,999", value: "H" },
                    { name: "$45,000 - $49,999", value: "I" },
                    { name: "$50,000 - $54,999", value: "J" },
                    { name: "$55,000 - $59,999", value: "K" },
                    { name: "$60,000 - $64,999", value: "L" },
                    { name: "$65,000 - $74,999", value: "M" },
                    { name: "$75,000 - $99,999", value: "N" },
                    { name: "$100,000 - $149,999", value: "O" },
                    { name: "$150,000 - $174,999", value: "P" },
                    { name: "$175,000 - $199,999", value: "Q" },
                    { name: "$200,000 - $249,999", value: "R" },
                    { name: "$250,000 Plus", value: "S" },
                ],
            },
            Household_Net_Worth: {
                name: "Household Net Worth",
                type: "checklist",
                options: [
                    { name: "Unknown" },
                    { name: "Less than $1", value: "A" },
                    { name: "$1 - $4,999", value: "B" },
                    { name: "$5,000 - $9,999", value: "C" },
                    { name: "$10,000 - $24,999", value: "D" },
                    { name: "$25,000 - $49,999", value: "E" },
                    { name: "$50,000 - $99,999", value: "F" },
                    { name: "$100,000 - $249,999", value: "G" },
                    { name: "$250,000 - $499,999", value: "H" },
                    { name: "Greater than $499,999", value: "I" },
                ],
            },
            Donor_Environmental: {
                name: "Interested in Green Living",
                type: "boolean",
            },
            Inferred_Age: {
                name: "Age",
                type: "number",
                min: "18",
                max: "100",
            },
            Landline_Phone_Number: {
                name: "Landline Phone Present",
                type: "boolean",
            },
            Cell_Phone: {
                name: "Cell Phone Present",
                type: "boolean",
            },
        },
    },
} as const;
